import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { tapResponse } from '@ngrx/operators';
import { Observable, switchMap } from 'rxjs';
import { IItemBase } from '../../../pages/items/items.interface';
import { ELoadStatus } from '../../../state/state.interface';
import { IBaseResponse } from '../../../utilities/http-utilities.service';
import { EItemPriority } from '../item-priority/item-priority.interface';

export interface IInlineItemPriorityComponentState {
  editItemLoading: ELoadStatus;
}

export interface IEditItemPriority {
  id: number;
  priority: EItemPriority | null;
}

@Injectable()
export class InlineItemPriorityStore extends ComponentStore<IInlineItemPriorityComponentState> {
  public readonly editItemLoading$: Observable<ELoadStatus> = this.select(
    (state: IInlineItemPriorityComponentState) => state.editItemLoading,
  );

  readonly editItemPriority = this.effect((trigger$: Observable<IEditItemPriority>) =>
    trigger$.pipe(
      switchMap((editItem: IEditItemPriority) => {
        this.patchState({ editItemLoading: ELoadStatus.loading });
        const params: HttpParams = new HttpParams().set('preventIsQuickColumnUpdate', true);

        return this.editItem(editItem, params).pipe(
          tapResponse(
            () => this.patchState({ editItemLoading: ELoadStatus.success }),
            // eslint-disable-next-line no-console
            (error) => console.error('Error loading data', error),
          ),
        );
      }),
    ),
  );

  constructor(private readonly http: HttpClient) {
    super({ editItemLoading: ELoadStatus.initial });
  }

  private editItem(item: IEditItemPriority, params: HttpParams): Observable<IBaseResponse<IItemBase>> {
    return this.http.patch<IBaseResponse<IItemBase>>(`items/${item.id}`, { priority: item.priority }, { params });
  }
}
